var React = require('react');

function IcNavHelpDesk (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 10C3 5.03 7.03 1 12 1C16.97 1 21 5.03 21 10V20C21 21.66 19.66 23 18 23H12V21H18C18.5523 21 19 20.5523 19 20V19H15V11H19V10C19 6.13 15.87 3 12 3C8.13 3 5 6.13 5 10V11H9V19H6C4.34 19 3 17.66 3 16V10ZM7 13V17H6C5.45 17 5 16.55 5 16V13H7ZM19 13V17H17V13H19Z","fill":"currentColor"}));
}

IcNavHelpDesk.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = IcNavHelpDesk;

IcNavHelpDesk.default = IcNavHelpDesk;
